import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import merchantService from '../../services/merchant';

const initialState = {
  loading: false,
  merchants: [],
  error: '',
  params: {
    page: 1,
    perPage: 10,
  },
  meta: {},
};

export const fetchMerchants = createAsyncThunk(
  'merchant/fetchMerchants',
  (params = {}) => {
    return merchantService
      .getAll({ ...initialState.params, ...params })
      .then((res) => res);
  }
);

const merchantSlice = createSlice({
  name: 'merchant',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchMerchants.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchMerchants.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.merchants = payload?.data?.map((item) => ({
        id: item?.id ?? null,
        uuid: item?.uuid ?? null,
        user_id: item?.user_id ?? null,
        name: item?.name ?? '',
        phone: item?.phone ?? '',
        description: item?.description ?? '',
        address: item?.address ?? '',
        pharmacy_code: item?.pharmacy_code ?? '',
        crn: item?.crn ?? '',
        tax_card_number: item?.tax_card_number ?? '',
        license_number: item?.license_number ?? '',
        governorate: item?.governorate ?? '',
        area: item?.area ?? '',
        landline_number: item?.landline_number ?? '',
        whatsapp_number: item?.whatsapp_number ?? '',
        pharmacist_name: item?.pharmacist_name ?? '',
        crn_image: item?.crn_image ?? null,
        tax_card_image: item?.tax_card_image ?? null,
        license_image: item?.license_image ?? null,
        pharmacy_front_image: item?.pharmacy_front_image ?? null,
        status: item?.status ?? 'new',
        status_note: item?.status_note ?? '',
        created_at: item?.created_at ?? null,
        updated_at: item?.updated_at ?? null,
        deleted_at: item?.deleted_at ?? null,
        user: item?.user ?? null,
      })) ?? [];
      state.meta = payload?.meta ?? {};
      state.params.page = payload?.meta?.current_page ?? 1;
      state.params.perPage = payload?.meta?.per_page ?? 10;
      state.error = '';
    });
    builder.addCase(fetchMerchants.rejected, (state, action) => {
      state.loading = false;
      state.merchants = [];
      state.error = action?.error?.message ?? 'An error occurred';
    });
  },
});

export default merchantSlice.reducer;
